import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=c149b1dc&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c149b1dc')) {
      api.createRecord('c149b1dc', component.options)
    } else {
      api.reload('c149b1dc', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=c149b1dc&", function () {
      api.rerender('c149b1dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2l8Ra0XPppbwW/JS/comp/childrenage.vue"
export default component.exports